import classes from 'components/common/Breadcrumbs/Breadcrumbs.module.scss';
import { Fragment } from 'react';
import { Link } from 'react-router-dom';

interface Props {
    list: {
        link: string;
        title: string;
    }[];
}

export const Breadcrumbs = ({ list }: Props) => {
    return list.length > 0 ? (
        <div className={classes.breadcrumbsContainer}>
            {list.map((item, index) => {
                return index === 0 ? (
                    <Link key={item.title} to={item.link}>
                        {item.title}
                    </Link>
                ) : (
                    <Fragment key={item.title}>
                        <span className={classes.arrowSeparator}> {'>'} </span>
                        <Link key={item.title} to={item.link}>
                            {item.title}
                        </Link>
                    </Fragment>
                );
            })}
        </div>
    ) : null;
};
